import { useQuery } from '@tanstack/react-query';
import type { OrderListResponse, OrderType } from '@metycle/shared';
import { apiRequest } from '@/lib/api-client';

// Order lookup behind the raise dialog's order combobox (launchpad parity).
// buyTicket/sellTicket carry only the ticket presence formatOrderCounterparties
// needs to gate the Own-stock substitution per side; the list endpoint already
// returns them on every item.detail.
export interface OrderSearchHit {
  id: string;
  orderType: OrderType;
  commodity: string | null;
  buyerName: string | null;
  supplierName: string | null;
  buyTicket: { id: string } | null;
  sellTicket: { id: string } | null;
}

const PAGE_SIZE = 10;

export function orderSearchQueryKey(search: string): readonly [string, string] {
  return ['hedging:order-search', search] as const;
}

export function useOrderSearch(search: string) {
  const trimmed = search.trim();
  return useQuery({
    queryKey: orderSearchQueryKey(trimmed),
    queryFn: async ({ signal }): Promise<OrderSearchHit[]> => {
      const response = await apiRequest<OrderListResponse>('/orders', {
        query: { search: trimmed || undefined, pageSize: PAGE_SIZE },
        signal,
      });
      return response.items.map((item) => ({
        id: item.id,
        orderType: item.orderType,
        commodity: item.commodity,
        buyerName: item.buyerName,
        supplierName: item.supplierName,
        buyTicket: item.detail.buyTicket,
        sellTicket: item.detail.sellTicket,
      }));
    },
    placeholderData: (previous) => previous,
  });
}
